module.exports = __webpack_public_path__ + "static/onegate-logo-website-751186f7eb3fe92359b7ba26e2fc96b2.png";